(function(){
  var cfg = window.NOQRO || {};
  var $ = function(s, r){ return (r || document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents){
    var v = (cents / 100);
    var s = v % 1 === 0 ? v.toLocaleString('he-IL') : v.toLocaleString('he-IL', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    return '₪' + s;
  }
  function esc(t){ var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  var R = document.documentElement;

  /* v1.8.3: one scroll lock for the cart drawer and the popup (closing one never unlocks the page while the other is open) */
  var lockN = 0;
  function lock(){ if (lockN++ === 0) R.classList.add('nq-lock'); }
  function unlock(){ if (lockN > 0 && --lockN === 0) R.classList.remove('nq-lock'); }
  cfg.lock = lock; cfg.unlock = unlock;

  /* v1.8.3: reveal on scroll – each element animates once when it enters the screen (opacity + translate only, no scroll-jacking) */
  (function(){
    window.__nqRv = true;
    if (!R.classList.contains('js-rv')) return;
    var pending = $$('.rv,.rv-kids,.rv-img');
    function clear(el){ el.classList.remove('rv', 'rv-kids', 'rv-img', 'in'); el.style.removeProperty('--rv-d'); }
    function show(el, i){
      var k = pending.indexOf(el); if (k < 0) return; pending.splice(k, 1);
      if (io) io.unobserve(el);
      var d = Math.min(i * 90, 450); el.style.setProperty('--rv-d', d + 'ms');
      el.classList.add('in');
      setTimeout(function(){ clear(el); }, d + 1700);
    }
    function order(list){ return list.sort(function(a, b){ var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect(); return (ra.top - rb.top) || (rb.right - ra.right); }); }
    var io = new IntersectionObserver(function(entries){
      order(entries.filter(function(e){ return e.isIntersecting; }).map(function(e){ return e.target; })).forEach(show);
    }, {rootMargin: '0px 0px -10% 0px', threshold: 0});
    pending.slice().forEach(function(el){
      if (el.getBoundingClientRect().bottom < 0) { pending.splice(pending.indexOf(el), 1); clear(el); }
      else io.observe(el);
    });
    /* a fast fling or an anchor jump can skip elements entirely; when scrolling settles, show anything already above the fold line */
    var st = null;
    window.addEventListener('scroll', function(){
      clearTimeout(st);
      st = setTimeout(function(){
        var h = window.innerHeight * .9, late = [];
        pending.slice().forEach(function(el){ var r = el.getBoundingClientRect(); if (r.bottom < 0) { pending.splice(pending.indexOf(el), 1); clear(el); } else if (r.top < h) late.push(el); });
        order(late).forEach(show);
      }, 140);
    }, {passive: true});
  })();

  /* header shadow on scroll */
  var hdr = $('.hdr');
  if (hdr) { var onS = function(){ hdr.classList.toggle('scrolled', window.scrollY > 10); }; window.addEventListener('scroll', onS, {passive: true}); onS(); }
  /* v1.8.3: header slides away when scrolling down, comes back on the first scroll up */
  if (hdr && cfg.autohide && hdr.parentElement) (function(){
    var sec = hdr.parentElement, last = Math.max(0, window.scrollY), tick = false;
    function upd(){
      tick = false;
      var y = Math.max(0, window.scrollY), d = y - last;
      if (Math.abs(d) < 8) return;
      var menu = document.getElementById('mobile-nav');
      var keep = y < 240 || d < 0 || R.classList.contains('nq-lock') || (menu && !menu.hasAttribute('hidden')) || sec.contains(document.activeElement);
      sec.classList.toggle('hdr-hide', !keep);
      last = y;
    }
    window.addEventListener('scroll', function(){ if (!tick) { tick = true; requestAnimationFrame(upd); } }, {passive: true});
  })();

  /* showcase color switcher */
  $$('[data-show]').forEach(function(sec){
    var imgs = $$('.stage img', sec), btns = $$('[data-show-i]', sec), name = $('[data-show-name]', sec), link = $('[data-show-link]', sec);
    var cur = 0, timer = null, visible = false, hold = false;
    var ms = +sec.getAttribute('data-show-auto') || 0;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(i){
      var b = btns[i]; if (!b) return; cur = i;
      imgs.forEach(function(im, k){ im.classList.toggle('on', k === i); });
      btns.forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (name) name.textContent = b.getAttribute('aria-label');
      if (link && b.getAttribute('data-href')) link.href = b.getAttribute('data-href');
    }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }
    function start(){ stop(); if (!ms || reduce || !visible || hold || btns.length < 2) return; timer = setInterval(function(){ go((cur + 1) % btns.length); }, ms); }
    btns.forEach(function(b){ b.addEventListener('click', function(){ go(+b.getAttribute('data-show-i')); start(); }); });
    sec.addEventListener('focusin', function(e){ if (e.target.matches(':focus-visible')) { hold = true; stop(); } });
    sec.addEventListener('focusout', function(){ hold = false; start(); });
    document.addEventListener('visibilitychange', function(){ if (document.hidden) stop(); else start(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function(en){ visible = en[0].isIntersecting; if (visible) start(); else stop(); }, {threshold: .3}).observe(sec);
    else { visible = true; start(); }
    if ('IntersectionObserver' in window) { var pre = new IntersectionObserver(function(en){ if (en[0].isIntersecting) { imgs.forEach(function(im){ im.loading = 'eager'; }); pre.disconnect(); } }, {rootMargin: '700px 0px'}); pre.observe(sec); }
    else imgs.forEach(function(im){ im.loading = 'eager'; });
  });

  /* mobile menu */
  var mt = $('[data-menu-toggle]'), mn = $('#mobile-nav');
  if (mt && mn) mt.addEventListener('click', function(){
    var open = mn.hasAttribute('hidden');
    if (open) mn.removeAttribute('hidden'); else mn.setAttribute('hidden', '');
    mt.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* product filters */
  $$('[data-filters]').forEach(function(group){
    var scope = group.closest('section');
    $$('button', group).forEach(function(b){
      b.addEventListener('click', function(){
        $$('button', group).forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var f = b.getAttribute('data-filter');
        $$('[data-tags]', scope).forEach(function(c){
          var tags = (c.getAttribute('data-tags') || '').split(',');
          if (f === 'all' || tags.indexOf(f) > -1) c.removeAttribute('hidden'); else c.setAttribute('hidden', '');
        });
      });
    });
  });

  /* cart drawer */
  var drawer = $('#cart-drawer'), shade = $('#cart-shade'), lastFocus = null;
  function openCart(){
    if (!drawer) { window.location.href = cfg.cartUrl || '/cart'; return; }
    lastFocus = document.activeElement;
    var wasOpen = !drawer.hasAttribute('hidden');
    drawer.removeAttribute('hidden'); shade.removeAttribute('hidden');
    if (!wasOpen) lock();
    var c = $('[data-cart-close]', drawer); if (c) c.focus();
  }
  function closeCart(){
    if (!drawer || drawer.hasAttribute('hidden')) return;
    drawer.setAttribute('hidden', ''); shade.setAttribute('hidden', '');
    unlock();
    if (lastFocus) lastFocus.focus();
  }
  $$('[data-cart-open]').forEach(function(b){ b.addEventListener('click', function(e){ if (drawer) { e.preventDefault(); refresh().then(openCart); } }); });
  $$('[data-cart-close]').forEach(function(b){ b.addEventListener('click', closeCart); });
  if (shade) shade.addEventListener('click', closeCart);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer && !drawer.hasAttribute('hidden')) closeCart(); });

  function setBadge(n, pop){
    $$('[data-cart-count]').forEach(function(b){
      b.textContent = n;
      if (n > 0) b.removeAttribute('hidden'); else b.setAttribute('hidden', '');
      if (pop) { b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); }
    });
    var lbl = $('[data-cart-title]'); if (lbl) lbl.textContent = (cfg.t && cfg.t.cartTitle || 'הסל שלך') + ' (' + n + ')';
  }

  function render(cart){
    if (!drawer) return;
    var items = $('[data-cart-items]', drawer);
    var th = cfg.freeShip || 0;
    var ship = $('[data-ship]', drawer);
    if (ship) {
      if (th > 0) {
        var left = th - cart.total_price;
        $('b', ship).textContent = left > 0 ? ('עוד ' + money(left) + ' למשלוח חינם') : 'יש לכם משלוח חינם!';
        $('i', ship).style.width = Math.min(100, Math.round(cart.total_price / th * 100)) + '%';
        ship.removeAttribute('hidden');
      } else ship.setAttribute('hidden', '');
    }
    if (!cart.item_count) {
      items.innerHTML = '<div class="empty">הסל ריק כרגע.<br><a href="' + (cfg.allUrl || '/collections/all') + '">לכל המוצרים</a></div>';
    } else {
      items.innerHTML = cart.items.map(function(it, i){
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
        return '<div class="line">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          '<div class="t"><b>' + esc(it.product_title) + '</b>' + variant + '<small>' + (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s> ' : '') + money(it.final_line_price) + '</small>' +
          (it.discounts && it.discounts.length ? it.discounts.map(function(d){ return '<small class="disc">' + esc(d.title) + ' · −' + money(d.amount) + '</small>'; }).join('') : '') +
          '<div class="q"><button type="button" data-q="' + (i + 1) + '" data-v="' + (it.quantity - 1) + '" aria-label="הפחתת כמות">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-q="' + (i + 1) + '" data-v="' + (it.quantity + 1) + '" aria-label="הוספת כמות">+</button></div></div>' +
          '<button type="button" class="rm" data-q="' + (i + 1) + '" data-v="0" aria-label="הסרת ' + esc(it.product_title) + '">הסרה</button></div>';
      }).join('');
    }
    if (cart.item_count === 1 && cfg.multiPct > 0) {
      items.insertAdjacentHTML('beforeend', '<a class="nudge" href="' + (cfg.allUrl || '/collections/all') + '"><i aria-hidden="true">+</i><span>מוסיפים עוד מוצר אחד? ' + cfg.multiPct + '% הנחה על שניהם, יורדת אוטומטית בסל.</span></a>');
    }
    var tot = $('[data-cart-total]', drawer); if (tot) tot.textContent = money(cart.total_price);
    var foot = $('.foot', drawer); if (foot) foot.style.display = cart.item_count ? '' : 'none';
    setBadge(cart.item_count);
  }

  function refresh(){ return fetch((cfg.root || '/') + 'cart.js', {headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); }).then(function(c){ render(c); return c; }); }

  if (drawer) drawer.addEventListener('click', function(e){
    var b = e.target.closest('[data-q]'); if (!b) return;
    b.disabled = true;
    fetch((cfg.root || '/') + 'cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({line: +b.getAttribute('data-q'), quantity: Math.max(0, +b.getAttribute('data-v'))})})
      .then(function(r){ return r.json(); }).then(render).catch(function(){ b.disabled = false; });
  });

  /* ajax add to cart for every product form */
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (!f.matches || !f.matches('form[action$="/cart/add"]') || !drawer) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]'), orig = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'מוסיף…'; }
    fetch((cfg.root || '/') + 'cart/add.js', {method: 'POST', headers: {'Accept': 'application/json'}, body: new FormData(f)})
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(){ return refresh(); })
      .then(function(c){ setBadge(c.item_count, true); openCart(); })
      .catch(function(err){ alertMsg(f, (err && (err.description || err.message)) || 'לא הצלחנו להוסיף לסל. נסו שוב.'); })
      .then(function(){ if (btn) { btn.disabled = false; btn.innerHTML = orig; } });
  });
  function alertMsg(f, m){
    var el = f.querySelector('[data-form-error]');
    if (!el) { el = document.createElement('p'); el.setAttribute('data-form-error', ''); el.setAttribute('role', 'alert'); el.className = 'errors'; el.style.marginTop = '12px'; f.appendChild(el); }
    el.textContent = m;
  }

  /* launch price: hide the label once its real end date has passed, even on a cached page */
  (function(){
    var d = new Date(), p = function(n){ return (n < 10 ? '0' : '') + n; };
    var today = d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
    $$('[data-launch-end]').forEach(function(el){ if (today > el.getAttribute('data-launch-end')) el.setAttribute('hidden', ''); });
  })();

  /* product page */
  $$('[data-product]').forEach(function(root){
    var dataEl = $('script[data-product-json]', root);
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = $('form[action$="/cart/add"]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var mainImg = $('[data-main-img]', root);
    var thumbs = $$('[data-thumb]', root);
    var selected = (product.selected || []).slice();

    var galCache = {}, galReq = 0;
    function galLoad(t){
      var k = t.getAttribute('data-thumb');
      if (galCache[k]) return galCache[k];
      var im = new Image(); im.decoding = 'async';
      if (mainImg && mainImg.sizes) im.sizes = mainImg.sizes;
      var ss = t.getAttribute('data-srcset'); if (ss) im.srcset = ss;
      im.src = t.getAttribute('data-src');
      galCache[k] = (im.decode ? im.decode() : Promise.resolve()).then(function(){ return im; }, function(){ return im; });
      return galCache[k];
    }
    function showMedia(src, alt, idx){
      if (!mainImg || !src) return;
      var tEl = thumbs.filter(function(t){ return t.getAttribute('data-thumb') === String(idx); })[0], ss = tEl && tEl.getAttribute('data-srcset');
      thumbs.forEach(function(t){ t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(idx) ? 'true' : 'false'); });
      var cap = $('[data-caption]', root);
      if (cap && tEl) cap.textContent = tEl.getAttribute('data-cap') || cap.textContent;
      var req = ++galReq;
      var swap = function(){
        if (req !== galReq) return;
        if (ss) mainImg.srcset = ss; else mainImg.removeAttribute('srcset');
        mainImg.src = src; if (alt) mainImg.alt = alt;
        mainImg.style.animation = 'none'; void mainImg.offsetWidth; mainImg.style.animation = '';
      };
      if (tEl) galLoad(tEl).then(swap); else swap();
    }
    /* warm the gallery so arrows switch instantly */
    var galWarm = function(){ thumbs.forEach(function(t){ galLoad(t); }); };
    if (thumbs.length > 1) { if ('requestIdleCallback' in window) requestIdleCallback(galWarm, {timeout: 2500}); else setTimeout(galWarm, 1200); }
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ showMedia(t.getAttribute('data-src'), t.getAttribute('data-alt'), t.getAttribute('data-thumb')); }); });
    /* gallery arrows + swipe */
    var galMain = mainImg ? mainImg.closest('.main') : null, galCount = $('[data-gal-count]', root);
    function curIdx(){ for (var k=0;k<thumbs.length;k++){ if (thumbs[k].getAttribute('aria-current')==='true') return k; } return 0; }
    function galGo(step){
      if (!thumbs.length) return;
      var n = (curIdx() + step + thumbs.length) % thumbs.length, t = thumbs[n];
      showMedia(t.getAttribute('data-src'), t.getAttribute('data-alt'), t.getAttribute('data-thumb'));
    }
    function updCount(){ if (galCount && thumbs.length) galCount.textContent = (curIdx()+1) + ' / ' + thumbs.length; }
    $$('[data-gal-step]', root).forEach(function(b){ b.addEventListener('click', function(){ galGo(parseInt(b.getAttribute('data-gal-step'),10)); updCount(); }); });
    thumbs.forEach(function(t){ t.addEventListener('click', updCount); });
    if (galMain && thumbs.length > 1) {
      var sx = null, sy = null;
      galMain.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, {passive:true});
      galMain.addEventListener('touchend', function(e){
        if (sx === null) return; var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { galGo(dx < 0 ? 1 : -1); updCount(); }
      });
      galMain.setAttribute('tabindex','0');
      galMain.addEventListener('keydown', function(e){ if (e.key==='ArrowLeft'){ galGo(1); updCount(); } else if (e.key==='ArrowRight'){ galGo(-1); updCount(); } });
    }

    $$('[data-opt]', root).forEach(function(b){
      b.addEventListener('click', function(){
        var pos = +b.getAttribute('data-opt');
        selected[pos] = b.getAttribute('data-val');
        $$('[data-opt="' + pos + '"]', root).forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var lab = $('[data-opt-label="' + pos + '"]', root); if (lab) lab.textContent = selected[pos];
        var v = product.variants.filter(function(v){ return v.options.every(function(o, i){ return o === selected[i]; }); })[0];
        update(v);
      });
    });

    function update(v){
      var add = form ? $('[type="submit"]', form) : null;
      if (!v) { if (add) { add.disabled = true; add.textContent = 'לא זמין'; } return; }
      if (idInput) idInput.value = v.id;
      $$('[data-price-now]', root.ownerDocument).forEach(function(p){ p.textContent = money(v.price); });
      updBundle(v.price);
      $$('[data-pair]', root).forEach(function(b){ b.setAttribute('data-main-price', v.price); b.setAttribute('data-main-available', v.available ? 'true' : 'false'); if (b.__calc) b.__calc(); });
      if (add) { add.disabled = !v.available; add.textContent = v.available ? 'הוספה לסל' : 'אזל מהמלאי'; }
      var rsx = document.querySelector('[data-restock]');
      $$('[data-sticky-add]').forEach(function(b){ b.disabled = !v.available && !rsx; b.textContent = v.available ? 'הוספה לסל' : (rsx ? 'עדכנו אותי' : 'אזל מהמלאי'); b.setAttribute('data-mode', v.available ? 'add' : 'notify'); });
      $$('[data-sticky-opt]').forEach(function(b){ b.setAttribute('aria-pressed', selected[+b.getAttribute('data-sticky-opt')] === b.getAttribute('data-val') ? 'true' : 'false'); });
      $$('[data-sticky-variant]').forEach(function(s){ s.textContent = v.title === 'Default Title' ? '' : ' · ' + v.title; });
      if (v.featured_media) {
        var th = thumbs.filter(function(t){ return t.getAttribute('data-media-id') === String(v.featured_media.id); })[0];
        if (th) showMedia(th.getAttribute('data-src'), th.getAttribute('data-alt'), th.getAttribute('data-thumb'));
        $$('[data-sticky-img]').forEach(function(i){ i.src = th ? th.getAttribute('data-src') : i.src; });
      }
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      }
    }

    /* bundle: 1 or 2 units, the discount itself is an automatic discount in admin */
    var bundle = $('[data-bundle]', root);
    function updBundle(price){
      if (!bundle) return;
      var pct = +bundle.getAttribute('data-bundle-pct') || 0, full = price * 2;
      var b1 = $('[data-b1]', bundle), b2 = $('[data-b2]', bundle), bw = $('[data-b2-was]', bundle);
      if (b1) b1.textContent = money(price);
      if (b2) b2.textContent = money(Math.round(full * (100 - pct) / 100));
      if (bw) bw.textContent = money(full);
    }

    var q = $('[data-qty]', root);
    var inp = q ? $('input', q) : null;
    function syncBundle(){
      if (!bundle || !inp) return;
      var want = (+inp.value || 1) >= 2 ? '2' : '1';
      $$('input[name="nq-bundle"]', bundle).forEach(function(r){ r.checked = r.value === want; });
    }
    if (q) {
      $$('button', q).forEach(function(b){ b.addEventListener('click', function(){ inp.value = Math.max(1, Math.min(99, (+inp.value || 1) + (+b.getAttribute('data-step')))); syncBundle(); }); });
      inp.addEventListener('change', syncBundle);
    }
    if (bundle && inp) $$('input[name="nq-bundle"]', bundle).forEach(function(r){
      r.addEventListener('change', function(){ if (r.checked) inp.value = r.value; });
    });

    /* sticky add-to-cart: mobile only, shows once the main form is scrolled past */
    var sticky = $('[data-sticky]'), anchor = form;
    var mobile = window.matchMedia ? matchMedia('(max-width:900px)') : {matches: true};
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var past = false;
      var setH = function(){ document.body.style.setProperty('--sticky-h', sticky.offsetHeight + 'px'); };
      var apply = function(){
        var on = past && mobile.matches;
        sticky.classList.toggle('on', on); document.body.classList.toggle('sticky-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('button', sticky).forEach(function(b){ b.tabIndex = on ? 0 : -1; });
      };
      new IntersectionObserver(function(en){ past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; apply(); }).observe(anchor);
      if (mobile.addEventListener) mobile.addEventListener('change', apply);
      setH(); window.addEventListener('resize', setH, {passive: true});
      var sb = $('[data-sticky-add]', sticky);
      if (sb) sb.addEventListener('click', function(){
        if (sb.getAttribute('data-mode') === 'notify') {
          var r = document.querySelector('[data-restock]');
          if (r) { r.scrollIntoView({behavior: 'smooth', block: 'center'}); var em = r.querySelector('input[type="email"]'); if (em) setTimeout(function(){ em.focus({preventScroll: true}); }, 450); }
          return;
        }
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
      $$('[data-sticky-opt]', sticky).forEach(function(b){
        b.addEventListener('click', function(){
          var pos = b.getAttribute('data-sticky-opt'), val = b.getAttribute('data-val');
          var main = $$('[data-opt="' + pos + '"]', root).filter(function(x){ return x.getAttribute('data-val') === val; })[0];
          if (main) main.click();
        });
      });
    }
  });

  /* v1.8.3: buy-together bundle – both products in one click; the % comes off through the automatic "any 2 products" discount */
  $$('[data-pair]').forEach(function(box){
    var root = box.closest('[data-product]') || document;
    var form = $('#product-form') || $('form[action$="/cart/add"]', root);
    var idIn = form ? $('input[name="id"]', form) : null;
    var btn = $('[data-pair-add]', box), sel = $('[data-pair-variant]', box), fixed = $('[data-pair-p]', box), err = $('[data-pair-err]', box);
    var pct = +box.getAttribute('data-pct') || 0, th = cfg.freeShip || 0;
    if (!btn || !idIn) return;
    function partner(){ var o = sel ? sel.options[sel.selectedIndex] : fixed; return {id: +(sel ? sel.value : o.getAttribute('data-id')), price: +o.getAttribute('data-price'), available: o.getAttribute('data-available') === 'true'}; }
    function set(q, t){ var e = $(q, box); if (e) e.textContent = t; }
    function calc(){
      var p = partner(), full = (+box.getAttribute('data-main-price') || 0) + p.price, now = Math.round(full * (100 - pct) / 100);
      set('[data-pair-full]', money(full)); set('[data-pair-now]', money(now)); set('[data-pair-save]', money(full - now));
      var fs = $('[data-pair-ship]', box); if (fs) fs.hidden = !(th > 0 && now >= th);
      var ok = box.getAttribute('data-main-available') === 'true' && p.available;
      btn.setAttribute('data-mode', ok ? 'add' : 'notify');
      btn.textContent = ok ? btn.getAttribute('data-add') : btn.getAttribute('data-notify');
    }
    box.__calc = calc;
    if (sel) sel.addEventListener('change', calc);
    btn.addEventListener('click', function(){
      if (btn.getAttribute('data-mode') !== 'add') {
        var r = $('[data-restock]');
        if (r && !r.hidden) { r.scrollIntoView({behavior: 'smooth', block: 'center'}); var em = $('input[type="email"]', r); if (em) setTimeout(function(){ em.focus({preventScroll: true}); }, 450); }
        else window.location.href = (box.querySelector('a.pair-it') || {}).href || cfg.allUrl;
        return;
      }
      var p = partner(); btn.disabled = true; btn.textContent = 'מוסיף…'; if (err) err.hidden = true;
      fetch((cfg.root || '/') + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: [{id: +idIn.value, quantity: 1}, {id: p.id, quantity: 1}]})})
        .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
        .then(function(){ return refresh(); })
        .then(function(c){ setBadge(c.item_count, true); openCart(); })
        .catch(function(e){ if (err) { err.textContent = (e && (e.description || e.message)) || 'לא הצלחנו להוסיף לסל. נסו שוב.'; err.hidden = false; } })
        .then(function(){ btn.disabled = false; calc(); });
    });
    calc();
  });

  refresh().catch(function(){});
})();
